import React from "react";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { uuid } from "uuidv4";

import { store as ModeOfSale } from "../../../../components/VerticalLayout/store";
import store, {
    setNumberActive,
    setNumberArchived,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setIsLoading,
    setKey,
} from "../store";
import { generalConfigStore, setItemsDisable } from "@store";

import ErrorToast from "@components/Common/ErrorTost";
import { ConfirmationArchive } from "../ConfirmationArchive";

import { ConfirmationActivationDeactivationMessageModal } from "../ConfirmationActivationDeactivationMessageModal";
import { GetSalesModesTypesAndTagsV2 } from "./helper";
import ConsultButton from "./ConsultButton";
import FavoriteButton from "./FavoriteButton";
import EditButton from "./EditButton";
import ToggleStateSwitch from "./ToggleStateSwitch";
import ArchiveButton from "./ArchiveButton";
import HistoryButton from "./HistoryButton";
import {
    archiveModeOfSaleFranchise,
    archiveModeSale,
    associateModeOfSaleCustomIcons,
    getModeOfSalePayload,
} from "./modeOfSaleCheckers";
import { showSuccessToast } from "@components/Common/SuccessToast";
import { useFetchGlobal } from "../../../../api/hooks";

export function CustomIcons({
    e,
    setShopId,
    setRowData,
    setSale,
    setDataIsUpdated,
    setSelectedRows,
    isModeOfSaleArchived,
    setSelectName,
    setSelectSales,
    setInputSaleMode,
    selectedRows,
    setLocalFilterActive,
    setIsConsult,
    setDataState,
    setSalesModesTypesAndTag,
    setFormState,
    isConsult,
    setSalesSupport,
    setTagsData,
    modalState,
    setModalState,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const {
        numberActive,
        numberArchived,
        shopsModeSaleData,
        archivedModeOfSaleFranchise,
        modeSaleData,
        isEdited,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { franchiseID, oneShop, userID, shopID, operatorID } = useSnapshot(
        ModeOfSale
    );
    const { itemsDisable } = useSnapshot(generalConfigStore);

    const [isArchiveModalOpened, setIsArchiveModalOpened] = React.useState<
        boolean
    >(false);
    const [
        isActivationDeactivationModalOpened,
        setIsActivationDeactivationModalOpened,
    ] = React.useState<boolean>(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    let dataAssociate: any[] = [];
    let dataArchive: any[] = [];
    const shopId = oneShop ? shopID : 0;
    if (!oneShop) {
        dataAssociate = associateModeOfSaleCustomIcons(
            shopsModeSaleData,
            e.selectedRow
        );
        dataArchive = archiveModeSale(shopsModeSaleData);
    } else {
        dataArchive = archiveModeOfSaleFranchise(archivedModeOfSaleFranchise);
    }

    async function activeModeOfSale() {
        toast.dismiss();
        setIsLoading(true);

        let dataModeOfSale = getModeOfSalePayload({
            type: "activate",
            selectedRow: e.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
        });

        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`;

        try {
            const data = await fetchGlobal<any>(apiUrlAdd, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataModeOfSale),
            });

            if (data.error) {
                throw new Error("error");
            }

            if (e.selectedRow.shopId !== "0") {
                if (
                    e.selectedRow.state === false &&
                    itemsDisable.find(
                        (item: any) =>
                            item.id === e.selectedRow.Id &&
                            item.shopId === e.selectedRow.shopId
                    ) === undefined
                ) {
                    const item = [
                        ...JSON.parse(JSON.stringify(itemsDisable)),
                        {
                            id: e.selectedRow.Id,
                            state: false,
                            shopId: e.selectedRow.shopId,
                        },
                    ];
                    setItemsDisable(item);
                    localStorage.setItem("itemsDisable", JSON.stringify(item));
                }
            }

            showSuccessToast(t("Sales method has been successfully activated"));
            setDataIsUpdated!(true);
            setIsLoading(false);
            setKey(uuid());
        } catch (e: any) {
            ErrorToast(`${t("There's an error")!}`);
            setIsLoading(false);
        }
    }

    async function favoriteModeOfSale() {
        toast.dismiss();
        setIsLoading(true);

        let dataModeOfSale = getModeOfSalePayload({
            type: "favorite",
            selectedRow: e.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
            modeSaleData,
        });

        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`;

        try {
            const data = await fetchGlobal<any>(apiUrlAdd, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataModeOfSale),
            });

            if (data.error) {
                throw new Error("error");
            }

            showSuccessToast(
                t(
                    `${
                        dataAssociate.length > 0
                            ? t(
                                  "Franchise favorite state has been successfully activated"
                              )
                            : t("Favorite state has been enabled successfully")
                    }`
                )
            );

            if (dataAssociate.length > 0) {
                setModalState((prev: any) => ({
                    ...prev,
                    isFavoriteModified: true,
                }));
            }

            setDataIsUpdated!(true);
            setTimeout(() => {
                setIsLoading(false);
            }, 2000);
        } catch (e) {
            ErrorToast(`${t("There's an error")!}`);
            setIsLoading(false);
        }
    }

    async function unfavoriteModeOfSale() {
        toast.dismiss();
        setIsLoading(true);

        let dataModeOfSale = getModeOfSalePayload({
            type: "unfavorite",
            selectedRow: e.selectedRow,
            userID,
            franchiseID,
            operatorID,
            uuidUser,
        });

        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale`;

        try {
            const data = await fetchGlobal<any>(apiUrlAdd, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataModeOfSale),
            });

            if (data.error) {
                throw new Error("error");
            }

            showSuccessToast(
                `${
                    dataAssociate.length > 0
                        ? t(
                              "Franchise favorite state has been successfully deactivated"
                          )
                        : t("Favorite state has been disabled successfully")
                }`
            );

            if (dataAssociate.length > 0) {
                setModalState((prev: any) => ({
                    ...prev,
                    isFavoriteModified: true,
                }));
            }

            setDataIsUpdated!(true);
            setIsLoading(false);
        } catch (e) {
            ErrorToast(`${t("There's an error")!}`);
            setIsLoading(false);
        }
    }

    async function isModeOfSaleUsed() {
        toast.dismiss();
        let isModeOfSaleUsed = false;
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/isModeOfSaleUsed?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&modeOfSale=${e.selectedRow.Id}`;

        try {
            const result = await fetchGlobal<any>(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (result.modeOfSaleUsed.length > 0) {
                isModeOfSaleUsed = true;
                ErrorToast(t("Attention, you cannot archive a used element."));
                setIsLoading(false);
            }
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
            setIsLoading(false);
        }

        if (!isModeOfSaleUsed) {
            const isSaleModeConsumed = await isModeOfSaleConsumed();
            if (isSaleModeConsumed) {
                ErrorToast(
                    t(
                        "Please note, you cannot archive an element used in a template"
                    )
                );
                setIsLoading(false);
            } else {
                setIsLoading(false);
                setIsArchiveModalOpened(true);
            }
        }
    }

    async function isSaleSupportArchived() {
        toast.dismiss();
        let isSaleSupportArchived = false;
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=archived`;

        try {
            const data = await fetchGlobal<any>(url, {
                method: "GET",
                headers: { "Accept-Language": i18nextLng },
            });

            data.data.forEach((elt: any) => {
                if (
                    e.selectedRow.support_vente.includes(elt[t("Sale support")])
                ) {
                    isSaleSupportArchived = true;
                }
            });
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
        }

        return isSaleSupportArchived;
    }

    async function isModeOfSaleConsumed() {
        toast.dismiss();
        let isModeOfSaleUsed = false;
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/consumedSettingGeneral?shopId=${e.selectedRow.shopId}&franchiseId=${franchiseID}&type=salesMethods`;

        try {
            const result = await fetchGlobal<any>(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (result.data.some((el: any) => el.id === e.selectedRow.Id)) {
                isModeOfSaleUsed = true;
            }
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
        }

        return isModeOfSaleUsed;
    }

    const handleAddSalesMethodClick = async () => {
        try {
            const configs = await GetSalesModesTypesAndTagsV2(
                franchiseID,
                shopId,
                fetchGlobal
            );
            const data = configs[0];

            if (!data) return;

            setSalesModesTypesAndTag(data);
            setModalState((prev: any) => ({
                ...prev,
                isAddModeOfSaleClicked: true,
            }));

            setLocalFilterActive(false);
        } catch (error) {
            console.error("Error fetching sales modes and tags:", error);
        }
    };
    if (e.selectedRow?.subRows !== undefined) return null;
    return (
        <React.Fragment>
            <div className="d-flex justify-content-around">
                {!modify ? (
                    <ConsultButton
                        e={e}
                        isEdited={isEdited}
                        setIsActionsClicked={setIsActionsClicked}
                        setActions={setActions}
                        setIsEdited={setIsEdited}
                        setRowData={setRowData}
                        setShopId={setShopId}
                        setSale={setSale}
                        setSelectName={setSelectName}
                        setSelectSales={setSelectSales}
                        setInputSaleMode={setInputSaleMode}
                        setLocalFilterActive={setLocalFilterActive}
                        setIsConsult={setIsConsult}
                        t={t}
                        setModalState={setModalState}
                        modalState={modalState}
                    />
                ) : (
                    <>
                        <FavoriteButton
                            e={e}
                            oneShop={oneShop}
                            isEdited={isEdited}
                            setIsActionsClicked={setIsActionsClicked}
                            setActions={setActions}
                            setIsEdited={setIsEdited}
                            setRowData={setRowData}
                            setShopId={setShopId}
                            setSale={setSale}
                            favoriteModeOfSale={favoriteModeOfSale}
                            unfavoriteModeOfSale={unfavoriteModeOfSale}
                            isModeOfSaleArchived={isModeOfSaleArchived}
                            isLoading={isLoading}
                            t={t}
                            setModalState={setModalState}
                        />
                        <EditButton
                            e={e}
                            isEdited={isEdited}
                            setIsActionsClicked={setIsActionsClicked}
                            setActions={setActions}
                            setIsEdited={setIsEdited}
                            setRowData={setRowData}
                            setShopId={setShopId}
                            setSale={setSale}
                            setSelectName={setSelectName}
                            setSelectSales={setSelectSales}
                            setInputSaleMode={setInputSaleMode}
                            setLocalFilterActive={setLocalFilterActive}
                            handleAddSalesMethodClick={
                                handleAddSalesMethodClick
                            }
                            isModeOfSaleArchived={isModeOfSaleArchived}
                            isLoading={isLoading}
                            oneShop={oneShop}
                            t={t}
                            setFormState={setFormState}
                            isConsult={isConsult}
                            i18nextLng={i18nextLng}
                            setSalesSupport={setSalesSupport}
                            setTagsData={setTagsData}
                            setModalState={setModalState}
                            modalState={modalState}
                            setSalesModesTypesAndTag={setSalesModesTypesAndTag}
                        />
                        <ToggleStateSwitch
                            e={e}
                            oneShop={oneShop}
                            isEdited={isEdited}
                            setIsActionsClicked={setIsActionsClicked}
                            setActions={setActions}
                            setIsEdited={setIsEdited}
                            setIsActivationDeactivationModalOpened={
                                setIsActivationDeactivationModalOpened
                            }
                            setDataState={setDataState}
                            isModeOfSaleArchived={isModeOfSaleArchived}
                            isLoading={isLoading}
                            t={t}
                            setModalState={setModalState}
                        />
                        <ArchiveButton
                            isModeOfSaleArchived={isModeOfSaleArchived}
                            isEdited={isEdited}
                            setIsActionsClicked={setIsActionsClicked}
                            setActions={setActions}
                            setIsEdited={setIsEdited}
                            e={e}
                            dataAssociate={dataAssociate}
                            t={t}
                            isModeOfSaleUsed={isModeOfSaleUsed}
                            oneShop={oneShop}
                            dataArchive={dataArchive}
                            isSaleSupportArchived={isSaleSupportArchived}
                            activeModeOfSale={activeModeOfSale}
                            numberActive={numberActive}
                            numberArchived={numberArchived}
                            setNumberActive={setNumberActive}
                            setNumberArchived={setNumberArchived}
                            setSale={setSale}
                            setSelectedRows={setSelectedRows}
                            isLoading={isLoading}
                            setModalState={setModalState}
                        />
                    </>
                )}
                <HistoryButton
                    e={e}
                    isEdited={isEdited}
                    setIsActionsClicked={setIsActionsClicked}
                    setActions={setActions}
                    setIsEdited={setIsEdited}
                    setRowData={setRowData}
                    setSelectedRows={setSelectedRows}
                    isLoading={isLoading}
                    oneShop={oneShop}
                    t={t}
                    setModalState={setModalState}
                />
            </div>

            {isArchiveModalOpened ? (
                <ConfirmationArchive
                    isModalOpened={isArchiveModalOpened}
                    setIsModalOpened={setIsArchiveModalOpened}
                    e={e}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                />
            ) : null}
            {isActivationDeactivationModalOpened ? (
                <ConfirmationActivationDeactivationMessageModal
                    isModalOpened={isActivationDeactivationModalOpened}
                    setIsModalOpened={setIsActivationDeactivationModalOpened}
                    e={e}
                    setDataIsUpdated={setDataIsUpdated}
                    modeOfSaleState={e.selectedRow.state}
                />
            ) : null}
        </React.Fragment>
    );
}
